export default __webpack_public_path__ + "static/media/people1.29a54f68.jpg";